import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  getFirstAllowedRoute,
  hasReportView,
} from '../helpers/employeePermissions';

/** Blocks operator report pages for SIP employees without report_view_own / report_view_all. */
export default function RequireReportView({ children }) {
  const employeeData = useSelector((state) => state.users.employeeData);

  if (!hasReportView(employeeData)) {
    return <Navigate to={getFirstAllowedRoute(employeeData)} replace />;
  }

  return children;
}
